import React, { useState, useEffect } from "react";
import "../css/homepage.css";
import MapliLogoWhite from "../assets/images/Hvit_Logo.svg";
import { getAuth } from "firebase/auth";
import Profil_Ikon_White from "../assets/images/Profil_Ikon_white.svg";
import { firestore } from "../firebase";
import { useLanguage } from "../LanguageContext";
import * as text from "../translation.json";

const auth = getAuth();

const Header = ({ faq }) => {
  const { language, setLanguage } = useLanguage();
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    auth.onAuthStateChanged(function (user) {
      if (user) {
        setLoggedIn(true);
      } else {
        setLoggedIn(false);
      }
    });
  }, [auth]);

  return (
    <header className='header'>
      <div className='headerLeft'>
        <a href='/'>
          <img src={MapliLogoWhite} height='40px' />
        </a>
      </div>
      <div className='headerRight'>
        {/* <a href='/prices' className='headerPricesWhite'>
          Priser
        </a> */}
        <div style={{ display: "flex", gap: 8, marginRight: 20 }}>
          <span
            className='fi fi-gb'
            onClick={() => setLanguage("en")}
            style={{
              cursor: "pointer",
              display: language === "en" ? "none" : "flex",
            }}
            title='English'
          />

          <span
            className='fi fi-no'
            onClick={() => setLanguage("no")}
            style={{
              cursor: "pointer",
              display: language === "no" ? "none" : "flex",
            }}
            title='Norsk'
          />
        </div>
        <a href='/faq' className='headerPricesWhite'>
          FAQ
        </a>
        {loggedIn ? (
          <a href='/MyBusiness' className='headerPricesWhite'>
            <img src={Profil_Ikon_White} style={{ height: "20px" }} />
          </a>
        ) : (
          <></>
        )}
        <label>
          <span className='headerPricesWhite'>|</span>
        </label>
        {faq !== undefined && faq ? (
          <a href='/login'>
            <p className='businessPageLoginButton'>{text[language].loginbtn}</p>
          </a>
        ) : (
          <p className='businessPageLoginText'>{text[language].loginbtn}</p>
        )}
      </div>
    </header>
  );
};

export default Header;
